import { useState, useEffect } from "react"
import { Modal, Button, Spinner} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { getFollowUpAction, createFollowUpAction } from "../../../../../store/actions/FollowUpAction"
import { showErrorAlert } from "../../../../../services/ErrorHandlingService"
import { formatDate } from "../../../../../utils/dateUtils"
const LeadFollowUp = () => {
  const dispatch = useDispatch()
  const { id } = useParams()

  const leadDetails = useSelector((state) => state.leadState?.leadDetails)
  const lead_id = leadDetails?.lead_id || id

  const followUpState = useSelector((state) => {
    // console.log("Full Redux State:", state)
    // console.log("FollowUp State:", state.followUps)
    return state.followUps || {}
  })

  const { followUps = [], isLoading = false, error = null } = followUpState

  const [showModal, setShowModal] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [currentEditId, setCurrentEditId] = useState(null)
  const [refreshTrigger, setRefreshTrigger] = useState(0)
  const [submitting, setSubmitting] = useState(false); 
  const [formData, setFormData] = useState({
    reason: "",
    next_action: "",
    next_follow_up_date: "",
  })

  useEffect(() => {
    // console.log("LeadFollowUp useEffect - lead_id:", lead_id)
    // console.log("Refresh trigger:", refreshTrigger)
    if (lead_id) {
      // console.log("Dispatching getFollowUpAction...")
      dispatch(getFollowUpAction(lead_id))
    }
  }, [lead_id, dispatch, refreshTrigger])

  useEffect(() => {
    // console.log("FollowUps changed:", followUps)
    // console.log("FollowUps length:", followUps.length)
  }, [followUps])

  const resetForm = () => {
    setFormData({
      reason: "",
      next_action: "",
      next_follow_up_date: "",
    })
  }

  const handleModalClose = () => {
    setShowModal(false)
    setIsEditMode(false)
    setCurrentEditId(null)
    resetForm()
  }

  const handleAddClick = () => {
    setIsEditMode(false)
    setCurrentEditId(null)
    resetForm()
    setShowModal(true)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (submitting) return;
    setSubmitting(true);
    if (!lead_id) {
      showErrorAlert("Lead ID not found. Please refresh and try again.", "error")
      return
    }

    // console.log("Submitting follow-up with data:", formData)
    // console.log("Lead ID:", lead_id)

    try {
      const result = await dispatch(createFollowUpAction(formData, lead_id))
      // console.log("Create follow-up result:", result)

      if (result && result.success) {
        // console.log("Follow-up created successfully, closing modal and refreshing...")
        handleModalClose()

        setRefreshTrigger((prev) => prev + 1)


        setTimeout(() => {
          // console.log("Refreshing follow-ups list...")
          dispatch(getFollowUpAction(lead_id))
        }, 1000)
      } else {
        // console.log("Follow-up creation failed:", result)
      }
    } catch (error) {
      console.error("Submit error:", error)
      showErrorAlert("Failed to save follow-up.", "error")
    }
    finally {
      setSubmitting(false); 
    }
  }


  // Debug information
  // console.log("LeadFollowUp Render Debug Info:", {
  //   lead_id,
  //   leadDetails,
  //   followUps,
  //   followUpState,
  //   followUpsLength: followUps.length,
  //   isLoading,
  //   refreshTrigger,
  // })

  return (
    <div className="card shadow-none">
      <div className="card-body">
        <div className="d-flex justify-content-end align-items-center mb-3">
          <Button variant="outline-primary" size="sm" onClick={handleAddClick} disabled={!lead_id}>
            Add Follow-Up
          </Button>
        </div>


        {/* Follow-Up List */}
        {isLoading ? (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p>Loading follow-ups...</p>
          </div>
        ) : followUps && followUps.length > 0 ? (
          <div>

            {followUps.map((item, index) => {
              // console.log("Rendering follow-up item:", item) 
              return (
                <div
                  key={item.followup_id || index}
                  className="mb-2 custom-timeline-panel timeline-panel bgl-dark p-3 rounded border"
                >
                  <h6 className="fw-bold">
                    {item.created_at
                      ? formatDate(item.created_at, false, true)
                      : "Date not available"}

                  </h6>

                  <p className="mb-0">
                    <strong>Reason:</strong> {item.followup_reason || item.reason || "N/A"}
                  </p>
                  <p className="mb-0">
                    <strong>Next Action:</strong> {item.next_followup_action || item.next_action || "N/A"}
                  </p>
                  <p className="mb-0">
                    <strong>Follow-Up Date:</strong>{" "}
                    {/* {item.next_followup_date || item.next_followup_date
                      ? new Date(item.next_followup_date || item.next_followup_date)
                        .toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                     
                        })
                        .replace(",", " at")
                      : "Date not available"} */}
                    {formatDate(item.next_followup_date) || "-"}
                  </p>

                </div>
              )
            })}
          </div>
        ) : (
          <li className="text-center text-muted">No FollowUp found.</li>
        )}

        {/* Follow-Up Modal */}
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Follow-Up" : "Add Follow-Up"}</Modal.Title>
          </Modal.Header>
          <form onSubmit={handleSubmit}>
            <Modal.Body>
              <div className="mb-3">
                <label className="form-label">
                  Reason for Follow-Up <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                  placeholder="Enter reason for follow-up"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Next Action <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="next_action"
                  value={formData.next_action}
                  onChange={handleChange}
                  placeholder="Enter next action"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Next Follow-Up Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="next_follow_up_date"
                  value={formData.next_follow_up_date}
                  onChange={handleChange}
                  min={new Date().toISOString().split("T")[0]}
                  required
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleModalClose}>
                Cancel
              </Button>
              {/* <Button type="submit" variant="primary">
                {isEditMode ? "Update" : "Save"}
              </Button> */}
              <Button type="submit" variant="primary" disabled={submitting}>
                {submitting ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    {isEditMode ? "Updating..." : "Saving..."}
                  </>
                ) : (
                  isEditMode ? "Update" : "Save"
                )}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  )
}

export default LeadFollowUp;
